import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LineItemTable from 'components/LineItemTable';
import LevelerTableRow from './levelerTableRow';
import {
   requestPhaseLevelerItems,
   savePhaseLevelerItem } from '../../../../../../../../shared/actionCreators/phase_items';


const ITEM_TYPE = 'leveler';

class LevelerTable extends Component {
  handleSave = (item) => {
    this.props.savePhaseLevelerItem(this.props.phaseId, item, ITEM_TYPE);
  }

  refreshLevelerTable = () =>
  this.props.requestPhaseLevelerItems(this.props.phaseId, ITEM_TYPE);

  render = () => {
    const { levelerItems } = this.props;
    return (<LineItemTable
      title="Leveler"
      refreshList={this.refreshLevelerTable}
      readOnly={!this.props.editable}
      cv={this.props.cv}
    >
      {levelerItems.map(item => <LevelerTableRow
        onSave={this.handleSave}
        key={item.id}
        readOnly={!this.props.editable}
        levelerItem={item}
      />)}
    </LineItemTable>);
  };
}

LevelerTable.defaultProps = {
  levelerItems: [], editable: true, cv: false,
};

LevelerTable.propTypes = {
  phaseId: PropTypes.string,
  requestPhaseLevelerItems: PropTypes.func,
  savePhaseLevelerItem: PropTypes.func,
  editable: PropTypes.bool.isRequired,
  levelerItems: PropTypes.array.isRequired,
  cv: PropTypes.bool,
};

const mapStateToProps = state => ({
  levelerItems: state.phase.levelers.items.data,
});

export default connect(mapStateToProps, {
  savePhaseLevelerItem,
  requestPhaseLevelerItems,
})(LevelerTable);




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/levelerTable.jsx